import React, { useState } from 'react'

import {
  InstructorTeam,
  LearningPath,
  PracticeBanner,
  ProgressSummary,
} from './_components'
import { PageContainer } from '../../_components'
import { useCourseSummaries } from '../../hooks/useCourseSummaries'
import { useGamificationProgress } from '../../hooks/useGamificationProgress'
import { useInstructorSummaries } from '../../hooks/useInstructorSummaries'

import { DashboardContainer } from './styles'

import type { ProgressPeriod } from './_components'

const Dashboard = () => {
  const [progressPeriod, setProgressPeriod] =
    useState<ProgressPeriod>('current-month')
  const progress = useGamificationProgress(progressPeriod)
  const { courses, loading: coursesLoading } = useCourseSummaries()
  const { instructors, loading: instructorsLoading } = useInstructorSummaries()

  return (
    <PageContainer>
      <DashboardContainer>
        <PracticeBanner />
        <ProgressSummary
          activity={progress.activity}
          practices={progress.practices}
          sharedChallenges={progress.sharedChallenges}
          period={progressPeriod}
          onPeriodChange={setProgressPeriod}
          loading={progress.loading}
          error={progress.error}
          hasActivity={progress.hasActivity}
          trend={progress.trend}
          gamification={progress.gamification}
        />
        <LearningPath courses={courses} loading={coursesLoading} />
        <InstructorTeam
          instructors={instructors}
          loading={instructorsLoading}
        />
      </DashboardContainer>
    </PageContainer>
  )
}

export default Dashboard
